import axios from "axios";

const GetQuoteService = {
  get: values => {
    return axios.post("/quotes/get-quote", values).then(({ data }) => data);
  }
};

export default GetQuoteService;
